<template>
  <div id="projectList">
    <Header />
    <button @click="goBack">
      Go Back
    </button>
    <div id="projectProfileData" on:click.stop="focusout">
      <div class="display-data">
        <label class="project-titles">
          Project：
        </label>
        <strong>
          <p v-show="!namefieldIsShown" class="project-datas" @click="showNameFields">{{ projectname }}</p>
        </strong>
        <input
          v-show="namefieldIsShown"
          ref="namefield"
          v-model="projectname"
          type="text"
          class="project-input-text"
          placeholder="What is your project name?"
          tabindex="0"
          @change="changed"
          @focusout="focusout"
        >
      </div>

      <div class="display-data">
        <label class="project-titles">
          Why：
        </label>
        <strong>
          <p v-show="!whyfieldIsShown" class="project-datas" @click="showWhyFields">{{ why }}</p>
        </strong>
        <textarea
          v-show="whyfieldIsShown"
          ref="whyfield"
          v-model="why"
          class="project-input-text"
          cols="30"
          rows="6"
          placeholder="Why is that?"
          tabindex="0"
          @change="changed"
          @focusout="focusout"
        />
      </div>

      <div class="display-data">
        <label class="project-titles">
          Stage：
        </label>
        <strong>
          <p v-show="!phasefieldIsShown" class="project-datas" @click="showPhaseFields">{{ phase }}</p>
        </strong>
        <select
          v-show="phasefieldIsShown"
          ref="phasefield"
          v-model="phase"
          type="text"
          class="project-input-select"
          placeholder="Why is that?"
          tabindex="0"
          @change="changed"
          @focusout="focusout"
        >
          <option disabled value="">
            Where are you at?
          </option>
          <option>Daydreaming</option>
          <option>Ideation / Sketching</option>
          <option>Conceptualizing</option>
          <option>Prototyping</option>
          <option>Development</option>
          <option>Finalizing</option>
          <option>Launching</option>
          <option>Publishing</option>
          <option>Funding</option>
        </select>
      </div>

      <div class="display-data">
        <label class="project-titles">
          Callout：
        </label>
        <strong>
          <p v-show="!calloutfieldIsShown" class="project-datas" @click="showCalloutFields">{{ callout }}</p>
        </strong>
        <select 
          v-show="calloutfieldIsShown"
          ref="calloutfield"
          v-model="callout"
          type="text"
          class="project-input-select"
          placeholder="Why is that?"
          tabindex="0"
          @change="changed"
          @focusout="focusout"
        >
          <option disabled value="">
            What are you looking for?
          </option>
          <option>Casual talk</option>
          <option>Interviewee</option>
          <option>Validation</option>
          <option>Teammates</option>
          <option>Founders</option>
          <option>Investor</option>
          <option>Publisher</option>
        </select>
      </div>

      <div class="display-data">
        <label class="project-titles">
          Show in Public：
        </label>
        <input
          ref="ispublicfield"
          v-model="isPublic"
          type="checkbox"
          class="project-input-checkbox"
          placeholder="Why is that?"
          tabindex="0"
          true-value="true"
          false-value="false"
          @change="changed"
          @focusout="focusout"
        >
      </div>
    </div>
    <div class="note-list">
      <h2>notes</h2>
      <noteList />
    </div>
    <Footer />
  </div>
</template>

<script>
import firebase from '@/firebase/firestore';
import router from '@/router.js';
import Footer from '@/components/footer.vue';
import Header from '@/components/header.vue';
import noteList from '@/components/noteList.vue';
import projectHandler from '@/js/projectHandler.js';
import { mapActions } from 'vuex';

export default {
  name: 'ProjectList',
  components: {
  Header,
  Footer,
  noteList,
  },
  data() {
    return {
      userId: firebase.auth().currentUser.uid,
      projectData: [],
      slug: this.$route.params.projectId,
      createdAt: null,
      editedAt: new Date(),
      projectname: null,
      why: null,
      phase: null,
      callout: null,
      isPublic: null,
      todolist: null,
      success: (this.$route.params.success),
      namefieldIsShown: false,
      whyfieldIsShown: false,
      phasefieldIsShown: false,
      calloutfieldIsShown: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    const uid = firebase.auth().currentUser.uid;
    const db = firebase.firestore().collection('user').doc(uid).collection('projects');
    db.where('slug', '==', to.params.projectId).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
        next(vm => {
          vm.createdAt = doc.data().createdAt;
          vm.projectname = doc.data().projectname;
          vm.why = doc.data().why;
          vm.phase = doc.data().phase;
          vm.callout = doc.data().callout;
          vm.isPublic = doc.data().isPublic;
        });
      });
    });
  },
  watch: {
    $route: 'fetchData',
  },
  mounted() {
  },
  methods: {
    ...mapActions(['fetchDatabase']),
    fetchData() {
      const db = firebase.firestore().collection('projects');
      db.where('slug', '==', this.$route.params.projectId).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(doc.id, ' => ', doc.data());
          this.createdAt = doc.data().createdAt;
          this.projectname = doc.data().projectname;
          this.why = doc.data().why;
          this.phase = doc.data().phase;
          this.isPublic = doc.data().isPublic;
          this.success = this.$route.params.success;
        });
      });
    },
    goBack() {
      router.push({ name: 'home', params: { userId: firebase.auth().currentUser.uid } });
    },
    showNameFields(){
      if(!this.namefieldIsShown){
        this.namefieldIsShown = true;
        this.$nextTick(() => this.$refs.namefield.focus());
      }
    },
    showWhyFields(){
      if(!this.whyfieldIsShown){
        this.whyfieldIsShown = true;
        this.$nextTick(() => this.$refs.whyfield.focus());
      }
    },
    showPhaseFields(){
      if(!this.phasefieldIsShown){
        this.phasefieldIsShown = true;
        this.$nextTick(() => this.$refs.phasefield.focus());
      }
    },
    showCalloutFields(){
      if(!this.calloutfieldIsShown){
        this.calloutfieldIsShown = true;
        this.$nextTick(() => this.$refs.calloutfield.focus());
      }
    },
    focusout(){
      this.namefieldIsShown = false;
      this.whyfieldIsShown = false;
      this.phasefieldIsShown = false;
      this.calloutfieldIsShown = false;
    },
    changed(){
      projectHandler.editProject(this.slug, this.editedAt, this.createdAt, this.userId, this.projectname, this.why, this.phase, this.callout, this.isPublic);
      this.fetchDatabase(this.userId);
    },  
  },
};

// 参考：https://qiita.com/akicho8/items/b4d071ea7eae562f529d
// 参考：https://qiita.com/b1san/items/6bc0be17cd6ed687520c
// 参考：https://stackoverflow.com/questions/36170425/detect-click-outside-element
//
// 日時の表示
// 参考：https://www.webopixel.net/javascript/1227.html

</script>

<style>
#projectList{
  padding: 10px;
}
#addProject{
  text-align: center;
  margin-top: 65px;
}
#projectProfileData{
  margin: 30px;
}
.project-titles{
  font-size: 0.7em;
}
.display-data{
  margin-bottom: 30px;
}
.project-datas{
  min-height:50px;
  width: 100%;
}
.project-datas-checkbox{
  min-height:50px;
  width: 100%;
}
.project-input-text{
  width: 100%;
  font-size: 1em;
  min-height: 50px;
  outline: none;
  background-color: #e5f1ea;
  border: solid #42b983 1px;
}
.project-input-select{
  width: 100%;
  font-size: 1em;
  height: 55px;
  outline: none;
  background-color: #e5f1ea;
  border: solid #42b983 1px;
}
.project-input-checkbox{
  border: solid #42b983 1px;
}
</style>